import React, { useLayoutEffect, useRef, useState } from 'react';
import styled from 'astroturf/react';
import useOnClickOutside from 'js/utils/hooks/useOnClickOutside';
import useScrollLock from 'js/utils/hooks/useScrollLock';
import ToolsMenu from 'js/header/FocusedNav/ToolsMenu';

type ToolsMenuProps = import('js/header/FocusedNav/ToolsMenu').Props;

const Background = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: -1;
`;

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;

  width: 400px;
  max-width: 80vw;
  overflow-y: auto;

  background: white;

  padding: 12px 12px 48px;
`;

type Props = ToolsMenuProps & {
  close: () => void;
  buttonRef: import('react').RefObject<HTMLButtonElement>;
};

const ToolsSidebar = ({ close, buttonRef, ...restProps }: Props) => {
  useScrollLock();

  const containerRef = useRef<HTMLDivElement>(null);
  const [topOffset, setTopOffset] = useState(0);

  useOnClickOutside([buttonRef, containerRef], close);

  useLayoutEffect(() => {
    const update = () => {
      if (buttonRef.current) {
        setTopOffset(buttonRef.current.getBoundingClientRect().bottom);
      }
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [buttonRef]);

  const onClose = (event: import('react').MouseEvent) => {
    if (event.target === event.currentTarget) {
      close();
    }
  };

  return (
    <Background onClick={onClose} style={{ top: topOffset }}>
      <Container ref={containerRef}>
        <ToolsMenu {...restProps} />
      </Container>
    </Background>
  );
};

export default ToolsSidebar;
